module.exports = __webpack_public_path__ + "f3f2cac9bc9f4d4b40c12387f0fc9f6a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/taco-s.png
// module id = 2132
// module chunks = 0